import { useCallback, useMemo } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getActivityRepliesUnreadStatus } from "../../../api/activityReply";
import { useAppState } from "../../../stores/appContext";
import { activityReplyKeys } from "./queryKey";

export const useActivityRepliesUnreadStatus = () => {
    const queryClient = useQueryClient();
    const appState = useAppState();

    const { data: data, isLoading } = useQuery<
        {
            activityId: string;
            activityReplyId: string;
            isUnread: boolean;
        }[]
    >({
        queryKey: activityReplyKeys.unreadStatus,
        queryFn: () => getActivityRepliesUnreadStatus(),
        enabled: appState.isLoggedIn,
    });

    const clearCache = useCallback(async () => {
        await queryClient.invalidateQueries({
            queryKey: activityReplyKeys.unreadStatus,
        });
    }, [queryClient]);

    const hasNewActivityReply = useMemo(
        () => data?.some((item) => item.isUnread) ?? false,
        [data]
    );

    // Activity単位の未読状態
    const hasNewActivityReplyByActivityId = useCallback(
        (activityId: string): boolean => {
            return (
                data?.some(
                    (item) => item.isUnread && item.activityId === activityId
                ) ?? false
            );
        },
        [data]
    );

    return {
        activityRepliesUnreadStatus: data ?? [],
        isLoading,
        clearCache,
        hasNewActivityReply,
        hasNewActivityReplyByActivityId,
    };
};
